
import { useContext, useMemo, useState } from "react";
import "./AddFriends.scss";
import Header from "../Header";
import { Friendship, User, UserProfileInfo } from "../../types"
import { useLocation, useNavigate } from "react-router-dom";
import AuthClient from "../../api/AuthClient";
import AddFriendsApi from "../../api/AddFriendsApi";
import UserProfileType from "../../api/enums/UserProfileType";
import { routes } from "../../routes/routes";
import { PartiesContext } from "../../GlobalContext/partiesContext";
import { syncMyPartiesAndSelectedPartyFromGroupId } from "../../utils/fetchAndSetMyPartiesInfo";

const AddAppFriends = () => {

    const { setMyPartiesInfoContextData, setSelectedPartyContextData } = useContext(PartiesContext);

    const navigate = useNavigate();
    const mediaUrl = process.env.REACT_APP_MEDIA_URL;

    const location = useLocation();
    const { appFriends, groupId, selectedFriendIds = [] } = location.state ?? {};
    const Friends: UserProfileInfo[] = appFriends?.Friends ?? [];
    const initiallySelectedFriends = useMemo(
        () => Friends.filter((friend) => selectedFriendIds.includes(friend.Id)),
        [Friends, selectedFriendIds]
    );
    const [selectedFriends, setSelectedFriends] = useState<UserProfileInfo[]>(initiallySelectedFriends);

    const handleToggleChange = (friend: UserProfileInfo) => {
        const friendIndex = selectedFriends.findIndex((f) => f.Id === friend.Id);

        if (friendIndex === -1) {
            setSelectedFriends([...selectedFriends, friend]);
        } else {
            const updatedFriends = [...selectedFriends];
            updatedFriends.splice(friendIndex, 1);
            setSelectedFriends(updatedFriends);
        }
    };

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleDone = () => {
        if (selectedFriends.length === 0 || isSubmitting) return;

        setIsSubmitting(true);

        const friends: User[] = selectedFriends.map((f) => ({
            Id: f.Id,
            FirstName: f.FirstName,
            Age: f.DateOfBirth
                ? Math.floor((Date.now() - new Date(f.DateOfBirth).getTime()) / (365.25 * 24 * 60 * 60 * 1000))
                : 0,
            Gender: f.Gender,
            ProfileType: UserProfileType.ClubrUser,
            DateOfBirth: f.DateOfBirth ? new Date(f.DateOfBirth) : new Date(),
        }));

        const friendship: Friendship = {
            Friends: friends,
            GroupId: groupId,
        };

        const authClient = new AuthClient();
        const addFriendsApi = new AddFriendsApi(authClient);

        addFriendsApi.addFriends(friendship).then(async (result) => {
            if (result.statusCode === 200) {
                await syncMyPartiesAndSelectedPartyFromGroupId(
                    authClient,
                    groupId,
                    setSelectedPartyContextData,
                    setMyPartiesInfoContextData
                );
                navigate(routes.MyPartyWithId(groupId), { replace: true });
            } else {
                alert("Failed to add friends. Please try again.");
                setIsSubmitting(false);
            }
        }).catch((error) => {
            console.error("Failed to add friends:", error);
            alert("Failed to add friends. Please try again.");
            setIsSubmitting(false);
        });
    };

    return (
        <>
            <Header />
            <div className="centerGroup">
                <div className="desktopUI">

                    <div className="row">
                        <div className="d-flex justify-content-start space col-6 mb-1">
                            <button className='BtnTop yellowTxt btn backBtn' onClick={() => navigate(-1)}>Back</button>
                        </div>

                        <div className="d-flex justify-content-end col-6 space">
                            <button className="BtnTop whiteTxt btn" onClick={handleDone} disabled={isSubmitting} >
                                {isSubmitting ? "Saving..." : "Done"}
                            </button>
                        </div>
                    </div>

                    {Friends.length > 0 ? (
                        <>
                            <div className="container">
                                {Friends.map((friend, index) => (
                                    <div key={index} className="friend-container clubCon">
                                        <input
                                            className="form-check-input checkC shadow-none shadow-none"
                                            type="checkbox"
                                            checked={selectedFriends.some((f) => f.Id === friend.Id)}
                                            onChange={() => handleToggleChange(friend)}
                                        />

                                        <div className="image-container">
                                            <img src={mediaUrl + friend.Id} className="f_Img" />
                                        </div>

                                        <div className="content_ text-start">
                                            <span className="whiteTxt mb-0">{`${friend.FirstName} ${friend.LastName}`}</span>
                                        </div>
                                    </div>

                                ))}
                            </div>
                            <div className="container">
                                <button className="doneBtn yellowTxt" onClick={handleDone} disabled={isSubmitting}>
                                    {isSubmitting ? "Saving..." : "Done"}
                                </button>
                            </div>
                        </>
                    ) : (
                        <p>
                            No friends were found!
                        </p>
                    )}

                </div>
            </div>
        </>
    );
};

export default AddAppFriends;
